import { useContext, useEffect, useState } from "react";
import { environmentAbbreviation } from "@coherehealth/common";
import { UserContext } from "../UserContext";

const ENV_RESTRICTED_PREFIX = "envRestricted_";

function filterRolesForEnvPrefix(roles: string[]): string[] {
  const env = environmentAbbreviation();
  if (env === "unknown" || env === "local") {
    return roles;
  }
  const thisEnvPrefix = `${ENV_RESTRICTED_PREFIX}${env}_`;
  return roles.reduce<string[]>((result, role) => {
    if (role.startsWith(ENV_RESTRICTED_PREFIX)) {
      if (role.startsWith(thisEnvPrefix)) {
        result.push(role.substring(thisEnvPrefix.length));
      }
    } else {
      result.push(role);
    }
    return result;
  }, []);
}
export default function useUserRoles() {
  const [userRoles, setUserRoles] = useState<Array<string> | undefined>();
  const { getUser } = useContext(UserContext);
  useEffect(() => {
    getUser().then((user) => {
      if (user?.roles) {
        const roles = user.roles.split(",");
        setUserRoles(filterRolesForEnvPrefix(roles));
      }
    });
  }, [getUser]);

  return userRoles;
}
